import { initTestimonialsCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initTestimonialsCarousel()
}, { once: true })
